export default __webpack_public_path__ + "static/media/500.c3c44d41.png";